<template>
  <div class="book-block" v-if="book">
    <div class="gallery" v-if="coverImages.length">
      <div class="cover">
        <img :src="coverImages[currentImage].url" :alt="book.title" />
      </div>
      <div class="gallery-dots" v-if="coverImages.length > 1">
        <button
          v-for="(img, i) in coverImages"
          :key="i"
          class="dot"
          :class="{ active: i === currentImage }"
          @click="currentImage = i"
        />
      </div>
    </div>
    <div class="book-info">
      <div class="specs-price" v-if="book.specs || priceLabel">
        <p class="specs" v-if="book.specs">{{ book.specs }}</p>
        <p class="price" v-if="priceLabel">{{ priceLabel }}</p>
      </div>
      <button class="btn-cart" v-if="priceLabel" @click="addToCart">Add to Cart</button>
    </div>
  </div>
</template>

<script setup>
  import { computed, ref } from 'vue'
  import { useStore } from '../KQL.js'
  import { pageFromPath } from '../helpers.js'
  import { useCartStore } from './CartStore.js'

  const kql = useStore();
  const cart = useCartStore();
  const props = defineProps(['block', 'page']);
  const currentImage = ref(0);

  const book = computed(() => {
    const uid = props.block.content.page?.[0];
    return uid ? pageFromPath(uid, kql.pages) : null;
  });

  const coverImages = computed(() => book.value?.coverimages ?? []);

  const priceLabel = computed(() => {
    const p = book.value?.price;
    if (!p || parseFloat(p) === 0) return null;
    return `$${parseFloat(p).toFixed(2)}`;
  });

  const addToCart = () => {
    if (book.value) cart.addItem(book.value);
  };
</script>

<style scoped>
  .book-block {
    display: flex;
    flex-direction: column;
    gap: 3rem;
  }

  /* Gallery: cover + dots */
  .gallery {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
  }

  .cover img {
    width: 100%;
    display: block;
    object-fit: contain;
    object-position: left top;
    max-height: 32rem;
  }

  .gallery-dots {
    display: flex;
    gap: 6px;
    justify-content: flex-start;
  }

  .dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.4);
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: background 0.2s;
    display: inline-block;
    font-size: 0;
  }

  .dot.active {
    background: white;
  }

  .dot:hover {
    background: rgba(255, 255, 255, 0.7);
    cursor: pointer;
  }

  /* Info: specs, price, buttons */
  .book-info {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .specs-price {
    display: flex;
    flex-direction: column;
  }

  .specs,
  .price {
    margin: 0;
    font-family: "Maison Neue Demi", sans-serif;
    font-size: 1.4rem;
    line-height: 1.4;
  }

  .price {
    margin-top: 1.4em;
  }

  .btn-cart {
    background: #f1f2f2;
    color: #895B5C;
    border-color: #f1f2f2;
    margin: 0 0 1.5rem;
    align-self: flex-start;
  }

  .btn-cart:hover {
    background: white;
    border-color: white;
  }
</style>
